/***************************************************************************/
"use client";
/***************************************************************************/

import { FormProvider as RHFFormProvider } from "react-hook-form";

const FormProvider = RHFFormProvider;

export { FormProvider };
